/* eslint-disable max-len */
<template>
  <v-card v-bind="innerValue.attr">
    <v-row>
      <v-col
        cols="12"
        v-if="
          innerValue.nodes.text1 &&
          innerValue.nodes.text1.data &&
          innerValue.nodes.text1.data.active
        "
      >
        <PRichText v-model="innerValue.nodes.text1.data" />
      </v-col>

      <v-col
        cols="12"
        v-if="
          innerValue.nodes.tableTextConfirm &&
          innerValue.nodes.tableTextConfirm.data &&
          innerValue.nodes.tableTextConfirm.data.active
        "
      >
        <TableAutoComplete
          v-model="tableId"
          v-bind="innerValue.nodes.tableTextConfirm.data.attr"
        />

        <PButton
          v-model="innerValue.nodes.tableTextConfirmButton.data"
          :loading="isLoading"
          @click="confirm()"
        />
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import PRichText from "./PRichText.vue";
import PButton from "./PButton.vue";
import TableAutoComplete from "../_includes/TableAutoComplete.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    PRichText,
    PButton,
    TableAutoComplete,
  },
  props: {
    value: Object,
  },
  computed: {
    selectedTableId() {
      const { tableId } = this.$route.params;
      if (tableId) {
        return tableId;
      }
      return null;
    },
  },
  data() {
    const { tableId } = this.$route.params;
    return {
      innerValue: this.value,
      tableId: tableId,
    };
  },
  computed: {
    ...mapState({
      session: (state) => state.session.data,
      error: (state) => state.session.error,
      isLoading: (state) => state.session.isLoading,
    }),
  },
  watch: {
    value(newValue) {
      this.innerValue = newValue;
    },
    selectedTableId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.tableId = newValue;
      }
    },
  },
  methods: {
    ...mapActions({
      moveTable: "session/moveTable",
    }),
    async confirm() {
      if (!window.parentIFrame) {
        await this.$store.dispatch("cart/setTable", this.tableId);
        await this.moveTable({
          id: this.session.id,
          data: {
            target_table_number: this.tableId,
          }
        });
        if (!this.error) {
          // No success snackbar: the redirect to the menu is confirmation enough.
          this.$router.push(`/menu`);
        } else {
          const message =
            this.error && this.error.target_table_number
              ? this.error.target_table_number.join("")
              : "Connection problem, please try again or contact our staff.";
          this.$store.dispatch('snackbar/error', message);
        }
      } else {
        alert(
          "You are in preview mode, all action is disabled in preview mode"
        );
      }
    },
  },
};
</script>
